import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  change: {
    id: 'change',
    defaultMessage: 'Change',
    description: 'A CTA to allow users to change their selected restaurant location.'
  },
  selectRestaurant: {
    id: 'selectRestaurant',
    defaultMessage: 'Select Restaurant',
    description: 'A CTA to allow the user to select the restaurant they wish to order from.'
  },
  ordersMustBePlacedHrsAhead: {
    id: ' ordersMustBePlacedHrsAhead',
    defaultMessage: 'Orders must be placed {hrs} hrs ahead!',
    description:
      'A note to users that they must place their order a certain number of hours ahead of time.'
  }
});
